<tabs class="row">
    <tab [tabTitle]="'glossary'"><glossary-editor #inner></glossary-editor></tab>
    <tab tabTitle="metadata"><metadata #inner></metadata></tab>
    <tab tabTitle="questions"><question-editor #inner></question-editor></tab>
    <tab tabTitle="word wall"><vocabulary-editor #inner></vocabulary-editor></tab>
    <tab tabTitle="layout"><layout-editor #inner></layout-editor></tab>
    <tab tabTitle="QA"><verifier #inner></verifier></tab>
</tabs>
<pipeline-save-modal></pipeline-save-modal>
